// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var LegalSettingsController = function ($scope, CompanySettings) {
    $scope.companySettings = CompanySettings.get();
    $scope.save = function () {
        $scope.companySettings.$update({}, function () {
            $scope.notifySuccess();
        });
    };
};
LegalSettingsController.$inject = ['$scope', 'CompanySettings'];
